import { get } from 'lodash';

export const URL_TERMS = 'https://anyword.com/anyword-terms-of-service/';
export const URL_PRIVACY_POLICY = 'https://anyword.com/privacy-policy';
export const URL_PRICING = 'https://anyword.com/pricing';
export const SUPPORT_URL =
  'https://support.anyword.com/hc/en-us/requests/new?utm_source=anyword_platform';
export const URL_VISIT_APPSUMO = 'https://appsumo.com/account/products';
export const URL_INFINITY_EXTENSION =
  'https://chrome.google.com/webstore/detail/anyword-for-chatgpt/jpeanighlianefpkkinhabdlhjalibej';

export const DEBOUNCED_CALL_STATUS = {
  started: 'started',
  success: 'success',
  error: 'error',
};

export const YOUTUBE_VIDEO_ID = {
  mobileDevicePage: 'LKeaJ_nv1iM',
  dataDrivenDocuments: '4Af3ziZtxIY',
  projectTypeDocument: 'vRYME_LoLtI',
  projectTypeDocumentUseCases: 'HLD2p8OyD6k',
  projectTypeDocumentInlineFunctions: 'upgAxfP6ZAQ',
  projectTypeOptimization: 'vqGjqrlqaXw',
  projectTypeBlog: 'kgBB0dmQslQ',
  explainerVideoBlogSEO: 'sl6zXMtoRco',
  explainerVideoPersonas: '7-IqPayeL1Q',
  explainerVideoWorkspaces: 'lGhcny-AZyY',
};

const EXPLAINER_VIDEO_PROPS = {
  [YOUTUBE_VIDEO_ID.projectTypeBlog]: {
    title: "Let's create a blog post",
  },
  [YOUTUBE_VIDEO_ID.explainerVideoBlogSEO]: {
    title: 'How to use SEO keywords',
  },
  [YOUTUBE_VIDEO_ID.projectTypeDocument]: {
    title: "Let's Explore Our Documents",
  },
  [YOUTUBE_VIDEO_ID.projectTypeDocumentUseCases]: {
    title: 'AnyCopy',
  },
  [YOUTUBE_VIDEO_ID.projectTypeDocumentInlineFunctions]: {
    title: 'Inline Functions',
  },
};

export const getExplainerVideoTitle = (mode) => get(EXPLAINER_VIDEO_PROPS, [mode, 'title']) || '';
